import React from "react";
import { observer, inject } from "mobx-react";
import { withTranslation } from "react-i18next";
import style from "./style.module.css";
import TermsModal from "../TermsModal";
import MapModal from "../MapModal";
import ThanksModal from "../../ThanksModal";
import ThanksCouponModal from "../../ThanksCouponModal";
import ValidSMSModal from "../../ValidSMSModal";
import APILoader from "../../APILoader";
import Geocode from 'react-geocode';
import CardNumberModal from "../CardNumberModal";
import ReactPixel from 'react-facebook-pixel';
import RegInput from "../../Registration/RegInput";

@inject((store) => {
  const { myShopApiStore, ifaceMngr } = store;
  return { myShopApiStore, ifaceMngr };
})

@observer
class PaymentOptionForm extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            errors: [],
            termsModalIsOpen: false,
            mapModalIsOpen: false,
            thanksModalIsOpen: false,
            smsModalIsOpen: false,
            apiLoaderIsOpen: false,
            isCheckedTerms: this.props.myShopApiStore.userToken ? true : false,
            cardNumberModalIsOpen: false
        }
    }
    
    optionBtnsStyle = (isCreditBtn = false) => {
        const { orderData, mainColor } = this.props.myShopApiStore;
        if(isCreditBtn){
            if(orderData.isCredit){
                return{
                    backgroundColor: mainColor,
                    color: "#FFFF" 
                }
            }
            else{
                return{
                    backgroundColor: "#eeeeee",
                    color: "#9b9a9a" 
                }
            }
        } else {
            if(!orderData.isCredit){
                return{
                    backgroundColor: mainColor,
                    color: "#FFFF" 
                }
            }
            else{
                return{
                    backgroundColor: "#eeeeee",
                    color: "#9b9a9a" 
                }
            }
        }
    }
    
    handleChange = (event) => {
        const { name, value, checked } = event.target;

        if(name === 'isCheckedTerms'){
            this.setState({[name]: checked})
        }
        else{
            this.props.myShopApiStore.setUserParams(name, value)
        }

        let errors = this.state.errors;
        const eIndex = errors.indexOf(name);
        if (eIndex > -1) {
            errors.splice(eIndex, 1);
            this.setState({
                errors: errors,
            });
        }
    }

   
    errorConditions = () => {
        const { validateUserParams } = this.props.myShopApiStore;
        const requiredFields = ['name', 'phone', 'city', 'streetName', 'streetNumber'];
        const errors = validateUserParams(requiredFields);
        
        if(!this.state.isCheckedTerms){
            errors.push('isCheckedTerms')
        }

        return errors;
    }

    setLatLngFromAddrsResp = async () => {
        const { streetName, streetNumber, city } = this.props.myShopApiStore.userParams;
        const { setDeliveryLatLng, setUserParams } = this.props.myShopApiStore;
        await Geocode.fromAddress(`${city} ${streetName} ${streetNumber}`).then(
            (response) => {
                const { lat, lng } = response.results[0].geometry.location;
                this.props.myShopApiStore.setDeliveryLatLng({lat, lng});
            },
            (error) => {
                console.error(error);
                setDeliveryLatLng({lat: 32.085300, lng: 34.781769});
                setUserParams('streetName', '');
            }
          );
    }

    handleSubmit = async (event) => {
        // event.preventDefault();
        const { shop } = this.props.myShopApiStore;
        shop.isBusiness && this.handleDeliveryGuyClick()

        const { orderData, registerUser } = this.props.myShopApiStore;

        if(this.state.apiLoaderIsOpen){ //cancel multiple (in a row) clicks on send button!
            return null;
        }

        const errors = this.errorConditions();

        if(!errors.length){
            
            this.openAPILoader()
            await this.setLatLngFromAddrsResp(); //set lat lng parameters
            const regResp = await registerUser();
            this.closeAPILoader();

            regResp.data ? this.openMapModal() : this.openSmsModal();
            
            if(orderData.isCredit){  //payment with credit!
                // //set lat lng parameters
                // await this.setLatLngFromAddrsResp();

                // if(!userToken){
                //     this.openAPILoader()
                //     await registerUser();
                //     this.closeAPILoader();
                //     this.openSmsModal();
                // }

                // else{//openning map!  (**next-step for new user -->> in closeSmsModal function!)
                //     this.openMapModal();
                // }
                
                ///->>>>
                // this.openAPILoader()
                // const regResp = await registerUser();
                // this.closeAPILoader();

                // regResp.data ? this.openMapModal() : this.openSmsModal();
                ///->>>>
                
            }
            else{ //payment to delivery guy!

                // //set lat lng parameters
                // await this.setLatLngFromAddrsResp();
                
                // if(!userToken){
                //     this.openAPILoader()
                //     await registerUser();
                //     this.closeAPILoader();
                //     this.openSmsModal();
                // }
                // else{ //openning map!  (**making order for new user -->> in closeSmsModal function!)
                //     this.openMapModal();
                // }

                // ///->>>>
                // this.openAPILoader()
                // const regResp = await registerUser();
                // this.closeAPILoader();

                // regResp.data ? this.openMapModal() : this.openSmsModal();
                ///->>>>
            }
        }
        else{
            this.setState({
                errors
            })
        }
    }

    openAPILoader = () => {
        this.setState({apiLoaderIsOpen: true})
    }

    closeAPILoader = () => {
        this.setState({apiLoaderIsOpen: false})
    }

    openSmsModal = () => {
        this.setState({smsModalIsOpen: true})
    }
    closeSmsModal = async (isWrongSMSCode=true) => {
        this.setState({smsModalIsOpen: false})
        
        // const { userToken } = this.props.myShopApiStore;
        // if(userToken){ //open map modal for new user
        //     this.openMapModal();
        // }
    }
    
    openThanksModal = () => {
        this.setState({thanksModalIsOpen: true})
    }

    closeThanksModal = () => {
        this.setState({thanksModalIsOpen: false})
        this.props.ifaceMngr.setActiveTopMenu("ShopMenu");
    }

    openCardNumberModal = () => {
        this.setState({cardNumberModalIsOpen: true})
    }

    closeCardNumberModal = () => {
        this.setState({cardNumberModalIsOpen: false})
    }
    
    handleCreditClick = () => {
        const { setOrderData } = this.props.myShopApiStore;

        if(process.env.REACT_APP_FACEBOOK_PIXEL != '') ReactPixel.track('AddPaymentInfo'); 

        setOrderData("isCredit", true);
    }

    handleDeliveryGuyClick = () => {
        const { setOrderData } = this.props.myShopApiStore;
        setOrderData("isCredit", false);
    }
    
    openTermsModal = () => {
        this.setState({termsModalIsOpen: true})
    }
    
    closeTermsModal = () => {
        this.setState({termsModalIsOpen: false})
    }

    openMapModal = () => {
        this.setState({mapModalIsOpen: true})
    }

    closeMapModal = () => {
        this.setState({mapModalIsOpen: false})
    }

    render() {
        if(this.props.currentStep !== 2){
            return null;
        } 
        const { userParams, orderData, mainColor,
                shop, setOrderData, hasPostCoupon,
                setOtherPaymentType } = this.props.myShopApiStore;
        const { t } = this.props;

        const sortedTypes = ['credit', 'cash', 'cibus', 'tenbis', 'goodi', 'delay', 'other'];
        const isCashBlocked = () => !userParams?.email?.includes('my-shop.co.il') && orderData.orderType === 'delivery' && shop.deliveryTypes && !shop.deliveryTypes.includes("self");
        const filteredPaymentTypes = sortedTypes.filter(pt => 
                    shop.paymentTypes.includes(pt) &&
                    !(pt === "cash" && isCashBlocked())
                );

        // setOrderData("isCredit", false); //ADDED !!!!!
        return (
            <div className={style.Container}>
                <div className={style.UserChoosing}>
                    {
                        shop.isBusiness
                        ?
                            ""
                        :
                            <div className={style.OptionBtns}>
                                {/* {canPayByCredit ? <button onClick={this.handleCreditClick} style={this.optionBtnsStyle(true)}>תשלום באשראי</button> : null}
                                {canPayByCash ? <button onClick={this.handleDeliveryGuyClick} style={this.optionBtnsStyle()}>תשלום לשליח</button> : null} */}
                            </div>
                    }
                    <div className={style.InputFields}>
                        <form onSubmit={this.handleSubmit}>
                            <div className={style.Inputs}>
                            {
                                orderData.isCredit
                                ? 
                                    <>
                                        <input type="text" name="name" value={userParams.name} onChange={this.handleChange} placeholder={t('full name')} style={{border: this.state.errors.includes('name') ? '1px solid #FF0000' : 'none'}}/>
                                        <RegInput type="tel" name="phone" value={userParams.phone} onChange={this.handleChange} placeholder={t('mobile phone')} style={{border: this.state.errors.includes('phone') ? '1px solid #FF0000' : 'none', textAlign: document.body.dir === 'rtl' ? 'right' : 'left' }}/>
                                        <input type="email" name="email" value={userParams.email} onChange={this.handleChange} placeholder={t('e-mail')} style={{border: this.state.errors.includes('email') ? '1px solid #FF0000' : 'none'}}/>
                                        <input type="text" name="city" value={userParams.city} onChange={this.handleChange} placeholder={t('city / town')} style={{border: this.state.errors.includes('city') ? '1px solid #FF0000' : 'none'}}/>
                                        <div className={style.StreetField}>
                                            <input type="text" name="streetName" value={userParams.streetName} onChange={this.handleChange} placeholder={t('street')} style={{border: this.state.errors.includes('streetName') ? '1px solid #FF0000' : 'none', /*color: 'transparent', textShadow: '0 0 0 #000000'*/}} />
                                        </div>
                                        <div className={style.TowInputInRow}>
                                            <input type="text" name="streetNumber" value={userParams.streetNumber} onChange={this.handleChange} placeholder={t('no. home')} style={{border: this.state.errors.includes('streetNumber') ? '1px solid #FF0000' : 'none'}}/>
                                            <input type="text" name="entranceCode" value={userParams.entranceCode} onChange={this.handleChange} placeholder={t('_entry code')}/>
                                        </div>
                                        <div className={style.TowInputInRow}>
                                            <input type="number" name="apartmentNumber" value={userParams.apartmentNumber} onChange={this.handleChange} placeholder={t('flat number')}/>
                                            <input type="number" name="floorNumber" value={userParams.floorNumber} onChange={this.handleChange} placeholder={t('floor')}/>
                                        </div>
                                        <div className={style.CheckTerm}>
                                            <input type="checkbox" name='isCheckedTerms' checked={this.state.isCheckedTerms} onChange={this.handleChange}/>
                                            <span style={{color: this.state.errors.includes('isCheckedTerms') ? '#FF0000' : '#FFF'}}>
                                                {t('I am approve that I have read') + " "}
                                            <span className={style.TextTermBtn} onClick={this.openTermsModal} style={{color: this.state.errors.includes('isCheckedTerms') ? '#FF0000' : 'rgb(255,255,255,0.75)'}}>{t('Conditions')}</span>
                                            {" " + t('I agree with all')}
                                            </span>
                                        </div>
                                    </>
                                : 
                                    <>
                                        <input type="text" name="name" value={userParams.name} onChange={this.handleChange} placeholder={t('full name')} style={{border: this.state.errors.includes('name') ? '1px solid #FF0000' : 'none'}}/>
                                        <RegInput type="tel" name="phone" value={userParams.phone} onChange={this.handleChange} placeholder={t('mobile phone') + '*'} style={{border: this.state.errors.includes('phone') ? '1px solid #FF0000' : 'none', textAlign: document.body.dir === 'rtl' ? 'right' : 'left'}}/>
                                        <input type="email" name="email" value={userParams.email} onChange={this.handleChange} placeholder={t('e-mail')} style={{border: this.state.errors.includes('email') ? '1px solid #FF0000' : 'none'}}/>
                                        <input type="text" name="city" value={userParams.city} onChange={this.handleChange} placeholder={t('city / town')} style={{border: this.state.errors.includes('city') ? '1px solid #FF0000' : 'none'}}/>
                                        <div className={style.StreetField}>
                                            {/* <div className={style.LeftElement}> */}
                                                {/* <label onClick={this.openMapModal}>לא מוצא את הכתובת?</label> */}
                                                {/* <label onClick={this.openMapModal}>לחץ כאן</label> */}
                                            {/* </div> */}
                                            <input type="text" name="streetName" value={userParams.streetName} onChange={this.handleChange} placeholder={t('street')} style={{border: this.state.errors.includes('streetName') ? '1px solid #FF0000' : 'none'}} />
                                        </div>
                                        
                                        <div className={style.TowInputInRow}>
                                            <input type="text" name="streetNumber" value={userParams.streetNumber} onChange={this.handleChange} placeholder={t('no. home')} style={{border: this.state.errors.includes('streetNumber') ? '1px solid #FF0000' : 'none'}}/>
                                            <input type="text" name="entranceCode" value={userParams.entranceCode} onChange={this.handleChange} placeholder={t('_entry code')} />
                                        </div>
                                        <div className={style.TowInputInRow}>
                                            <input type="number" name="apartmentNumber" value={userParams.apartmentNumber} onChange={this.handleChange} placeholder={t('apartment')}/>
                                            <input type="number" name="floorNumber" value={userParams.floorNumber} onChange={this.handleChange} placeholder={t('floor')}/>
                                        </div>
                                        <div className={style.CheckTerm}>
                                            <input type="checkbox" name='isCheckedTerms' checked={this.state.isCheckedTerms} onChange={this.handleChange}/>
                                            <span style={{color: this.state.errors.includes('isCheckedTerms') ? '#FF0000' : 'rgb(255,255,255)'}}>
                                            {t('I am approve that I have read') + " "}
                                            <span className={style.TextTermBtn} onClick={this.openTermsModal} style={{color: this.state.errors.includes('isCheckedTerms') ? '#FF0000' : '#FFF'}}>{t('Conditions')}</span>
                                            {" " + t('I agree with all')}
                                            </span>
                                        </div>
                                    </>
                            }
                            </div>
                            <div className={style.BottomBtns}>
                                {/* <button type="submit" style={{backgroundColor: mainColor}}>שלח</button> */}

                                {filteredPaymentTypes.map((pt, index) => 
                                        <button key={index} type="button" style={{backgroundColor: mainColor}} onClick={() => {
                                                switch(pt){
                                                    case 'credit':
                                                        this.handleCreditClick();
                                                        this.handleSubmit();
                                                        break;
                                                    case 'cash':
                                                        this.handleDeliveryGuyClick();
                                                        this.handleSubmit();
                                                        break;
                                                    case 'cibus':
                                                    case 'tenbis':
                                                    case 'goodi':
                                                        this.handleDeliveryGuyClick();
                                                        setOtherPaymentType(pt);
                                                        this.openCardNumberModal();
                                                        break;
                                                    default:
                                                        this.handleDeliveryGuyClick();
                                                        setOtherPaymentType(pt);
                                                        this.handleSubmit();
                                                        break;
                                                }
                                            }}>{t(pt === 'cash' ? 'cash to the courier' : (pt === 'credit' ? 'credit card' : pt))}
                                        </button>
                                )}
                                <button type="button" 
                                    style={{backgroundColor: 'unset', border: '2px solid rgb(255, 255, 255, 0.3)'}}
                                    onClick={this.props.prevStep}>{t('back')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div className={style.Modals}>
                    <CardNumberModal closeModal={this.closeCardNumberModal}
                                     modalIsOpen={this.state.cardNumberModalIsOpen}
                                     handleSendClick={this.handleSubmit}
                                     />
                    <TermsModal closeModal={this.closeTermsModal} modalIsOpen={this.state.termsModalIsOpen} />
                    {
                        hasPostCoupon
                        ?
                            <ThanksCouponModal closeModal={this.closeThanksModal} modalIsOpen={this.state.thanksModalIsOpen} />
                        :
                            <ThanksModal closeModal={this.closeThanksModal} modalIsOpen={this.state.thanksModalIsOpen} />
                    }
                    <ValidSMSModal closeModal={this.closeSmsModal} modalIsOpen={this.state.smsModalIsOpen}
                                   openMapModal={this.openMapModal} action="Delivery" />
                    <APILoader modalIsOpen={this.state.apiLoaderIsOpen} />
                    <MapModal openBasket={this.props.openBasket} closeModal={this.closeMapModal} openSmsModal={this.openSmsModal}
                              modalIsOpen={this.state.mapModalIsOpen} nextStep={this.props.nextStep}
                              openThanksModal={this.openThanksModal} closeThanksModal={this.closeThanksModal}
                              thanksModalIsOpen={this.state.thanksModalIsOpen}
                              />

                </div>
            </div>
        )
    }
}

export default withTranslation()(PaymentOptionForm);
